import { globalReducer, GlobalState } from './global/reducer'
import { accountReducer, AccountState } from './account/reducer'
import { NewUserFormWizardReducer, NewUserFormWizardState } from './wizardNewUser/reducer'
import { SpareAxleRequestFormWizardReducer, SpareAxleRequestWizardState } from './wizardSpareAxleRequest/reducer'

export interface RootState {
  readonly global: GlobalState
  readonly account: AccountState
  readonly newUserWizard: NewUserFormWizardState
  readonly spareAxleRequestWizard: SpareAxleRequestWizardState
}

export const rootReducer = {
  global: globalReducer,
  account: accountReducer,
  newUserWizard: NewUserFormWizardReducer,
  spareAxleRequestWizard: SpareAxleRequestFormWizardReducer,
}
